'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _flow = require('./flow.component');

var _flow2 = _interopRequireDefault(_flow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var flowModule = _angular2.default.module('app.flow', [_angularUiRouter2.default]).config(function ($stateProvider) {
  "ngInject";

  $stateProvider.state('flow', {
    url: '/flow',
    template: '<flow></flow>'
  });
}).component('flow', _flow2.default);

exports.default = flowModule;


/** WEBPACK FOOTER **
 ** ./client/app/containers/flow/flow.js
 **/